import { render, staticRenderFns } from "./RentalItemsUser.vue?vue&type=template&id=20a93b00"
import script from "./RentalItemsUser.vue?vue&type=script&lang=js"
export * from "./RentalItemsUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports